import styled from 'styled-components';
import { breakpoints } from 'themes/helpers';

export const Wrapper = styled.div`
  padding: 0 0 40px;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;

  @media (min-width: ${() => breakpoints.tablet}px) {
    flex-direction: column;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 140px;
  height: 140px;
  max-width: 100vw;
  max-height: 100vw;
  margin: 0 auto 20px auto;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const Info = styled.div`
  padding: 0 20px;
`;
